import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import Header from "../components/Header";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("polling");
  const [order, setOrder] = useState(null);
  const cancelled = params.get("cancelled");
  const sid = params.get("session_id");

  useEffect(() => {
    if (cancelled) {
      setStatus("cancelled");
      // Tell the backend the customer bailed so their Apex Rewards
      // (redemption reservation) + promo usage are released immediately
      // instead of waiting 24h for Stripe's session-expired webhook.
      // Fire-and-forget — the endpoint is idempotent.
      if (sid) api.post(`/payments/cancel/${sid}`).catch(() => {});
      return;
    }
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const iv = setInterval(async () => {
      tries++;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); setOrder(data.order_id); clearInterval(iv); }
        else if (data.payment_status === "failed" || data.payment_status === "expired") { setStatus("failed"); clearInterval(iv); }
        if (tries > 20) { clearInterval(iv); setStatus("timeout"); }
      } catch (err) {
        // transient polling error — keep retrying, surface for diagnostics
        if (process.env.NODE_ENV === "development") {
          console.debug("payment status poll error", err?.response?.status || err?.message);
        }
      }
    }, 2500);
    return () => clearInterval(iv);
  }, [sid, cancelled]);

  return (
    <div>
      <Header/>
      <div className="max-w-md mx-auto pt-32 px-4 text-center">
        <div className="vault-card p-10">
          {status === "polling" && (<><Loader2 className="w-12 h-12 text-[var(--av-gold)] mx-auto animate-spin mb-4"/><h1 className="font-serif text-2xl gold-text">Verifying payment…</h1></>)}
          {status === "paid" && (<><CheckCircle2 className="w-14 h-14 text-[var(--av-gold)] mx-auto mb-4"/><h1 className="font-serif text-3xl font-bold gold-text mb-2">Payment Confirmed</h1><p className="text-[var(--av-text-dim)] mb-6">Order {order} is now in our fulfilment queue.</p><Link data-testid="view-order-btn" to="/my-vault/orders" className="btn-gold">View Order</Link></>)}
          {(status === "cancelled" || status === "failed" || status === "timeout" || status === "error") && (<><XCircle className="w-14 h-14 text-red-500 mx-auto mb-4"/><h1 className="font-serif text-2xl text-red-400 mb-2">{status === "cancelled" ? "Payment Cancelled" : "Payment not verified"}</h1><p className="text-[var(--av-text-dim)] mb-6">We couldn't verify your payment, so your order has not been sent for fulfilment. Please contact support if you believe this is an error.</p><Link to="/store" className="btn-outline-gold">Back to Store</Link></>)}
        </div>
      </div>
    </div>
  );
}
